<mat-card class="puesta-dialog">
  <app-card-header
    icono="table_lamp"
    [title]="title"
    [draggable]="true"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form) {
    <form [formGroup]="form" autocomplete="off" (ngSubmit)="enviar()">
      <mat-card-content class="card-content-crear">
        <!-- Datos -->
        <app-content-card
          title="Datos de la Puesta"
          icon="table_lamp"
          color="blue"
        >
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Identificación</mat-label>
              <input matInput formControlName="identificacion" />
              <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>

            <!-- Grupo de puestas (grupos categoría 'Puesta') -->
            <app-grupo-selector
              [idCliente]="puesta?.idCliente"
              categoria="Puesta"
              formControlName="idsGrupos"
              [multiple]="true"
            ></app-grupo-selector>
          </section>
        </app-content-card>

        <!-- Perfiles de Configuración -->
        <app-content-card
          title="Perfiles de Configuración"
          icon="settings"
          color="purple"
        >
          <section class="inputs-group">
            <!-- Perfil(es) a nivel puesta: uno por tipo de luminaria -->
            <div
              style="width: 100%; display: flex; gap: 8px; align-items: center"
            >
              <ng-select
                [items]="perfilesConfig"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idsPerfilConfig"
                [multiple]="true"
                placeholder="Perfiles (opcional)"
                [notFoundText]="'No hay perfiles disponibles'"
                appendTo="body"
                style="flex: 1"
              >
                <ng-template ng-option-tmp let-item="item">
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      line-height: 1.3;
                    "
                    [class.option-disabled]="perfilDeshabilitado(item)"
                  >
                    <span>{{ item.nombre }}</span>
                    <small
                      style="margin-top: 2px; color: #666; font-size: 12px"
                    >
                      Tipo: {{ item.tipoConfig || 'Sin tipo' }}
                    </small>
                  </div>
                </ng-template>
              </ng-select>
              @if (helper.tienePermiso('Luminarias - Editar')) {
                <button
                  irxBotonIcono="borde"
                  tono="primario"
                  tamano="campo"
                  type="button"
                  tooltip="Crear perfil"
                  (click)="crearPerfil()"
                  style="flex-shrink: 0; margin-top: -12px"
                >
                  <mat-icon>add</mat-icon>
                </button>
              }
            </div>
            @if (form.get('idsPerfilConfig')?.errors?.['tipoDuplicado']) {
              <small style="color: var(--theme-warn-700, #b00020)">
                No se permiten dos perfiles del mismo tipo. Quitá uno de los
                duplicados.
              </small>
            }
          </section>
        </app-content-card>

        <!-- Ubicación: la puesta es la fuente de verdad de la georreferencia.
             La dirección se completa automáticamente al ubicar en el mapa. -->
        <app-content-card title="Ubicación" icon="location_on" color="orange">
          <section class="inputs-group">
            <div class="mapa-embebido-wrapper">
              <app-mapa-ubicar
                [raster]="'google'"
                [form]="geojson"
                [sinValorPorDefecto]="true"
                [centrarA]="centrarA"
                [enableAutocomplete]="true"
                [precision]="9"
                (direccion)="patchDireccion($event)"
              ></app-mapa-ubicar>
            </div>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  }
</mat-card>
